/**
 * Shared constants for authentication and path preservation
 */

/** Key used to store the pre-authentication path in sessionStorage */
export const PRE_AUTH_PATH_KEY = 'preAuthPath';
